import axios from "axios";
import { del, get, post, patch,  put } from "./sessions_api_helper";
import * as url from "./sessions_url_helper";





// Get features
export const getSessions = () => get(url.GET_SESSIONS);


// Add feature
export const addNewSession = (session) => post(url.ADD_NEW_SESSION, session);
//export const addNewBranch = branch => post(url.ADD_NEW_SESSION, JSON.stringify(branch));




// update feature
//export const updateFeature = feature => put(url.UPDATE_ACTION, feature);
export const updateSession= (session) => patch(`${url.UPDATE_SESSION}/${session.uuid}`,  session);


// delete series categories
//export const deleteFeature = feature => del(url.DELETE_ACTION, { headers: { feature } });
export const deleteSession = (session) => del(`${url.DELETE_SESSION}/${session.id}`);

// Ajouter à la suite des fonctions existantes
//export const getSessionResults = (filters) => get(url.GET_SESSION_RESULTS, { params: filters });
// session_id intégré dans l'URL + filtres en query params
//export const getSessionResults = ({ session_uuid, ...filters }) => get(`${url.GET_SESSION_RESULTS}/${session_uuid}/results`, { params: filters });
/*
export const getSessionResults = ({ session_uuid, exam_uuid, ...filters }) => 
    get(`${url.GET_SESSION_RESULTS}/${session_uuid}/results`, { 
        params: { 
            exam_uuid: exam_uuid, // Ajout de l'UUID de l'examen ici
            ...filters 
        } 
    });

*/

    // On déstructure session_uuid et exam_uuid pour les mettre dans le path
export const getSessionResults = ({ session_uuid, exam_uuid, ...filters }) => 
    get(`${url.GET_SESSION_RESULTS}/${session_uuid}/exam/${exam_uuid}/results`, { 
        params: filters // Le reste (semestre, niveau) reste en query string (?page=1...)
    });


//export const proclamerSession = (payload) =>post(`${url.PROCLAMER_SESSION}/${session_uuid}`, payload);


/*
export const proclamerSession = ({ session_uuid, study_level_id }) =>
  post(`${url.PROCLAMER_SESSION}/${session_uuid}`, {
    study_level_id,
  });

  */


  /*
  export const proclamerSession = ({ session_uuid, study_level_id, semester_id }) =>
  post(`${url.PROCLAMER_SESSION}/${session_uuid}`, {
    study_level_id,
    semester_id
    
  });

  */

  // 2. Correction de la PROCLAMATION : Il faut transmettre l'exam_uuid au backend !
export const proclamerSession = ({ session_uuid, exam_uuid, study_level_id, semester_id }) =>
  post(`${url.PROCLAMER_SESSION}/${session_uuid}`, {
    exam_uuid,      // <--- INDISPENSABLE : doit être envoyé au contrôleur Laravel
    study_level_id,
    semester_id
});



  /*

  export const getProclamationApi = (params) => {
    console.log("PARAMS SENT:", params);
    return get(url.GET_PROCLAMATION_RESULT, params);
};

*/

//export const getProclamationApi = (filters) => { return get(url.GET_PROCLAMATION_RESULT, { params: filters })};



//export const getProclamationResults = ({ session_uuid, ...filters }) => get(`${url.GET_PROCLAMATION_RESULTS}/${session_uuid}/proclamation-results`, { params: filters });

// Récupérer les résultats de proclamation
//export const getProclamationResults = ({ session_uuid, ...filters }) => get(`${url.GET_PROCLAMATION_RESULTS}/${session_uuid}`, { params: filters });



 export const getProclamationResults = ({ session_uuid, exam_uuid, ...filters }) =>get(`${url.GET_PROCLAMATION_RESULTS}/session/${session_uuid}/exam/${exam_uuid}`, {

    params: filters

});


// Sauvegarder le verdict annuel (Art 11/12)
export const saveFinalDecision = data => post(url.SAVE_FINAL_DECISIONS, data);

// Récupérer l'historique des verdicts
export const getFinalDecisions = filters => get(url.GET_FINAL_DECISIONS, { params: filters });


export const runAnnualDeliberation = (payload) => post(url.RUN_ANNUAL_DELIBERATION, payload);

//export {getLoggedInUser,};
